module.exports = require("lodash.snakecase");


//////////////////
// WEBPACK FOOTER
// external "lodash.snakecase"
// module id = 4
// module chunks = 0